import isEmpty from 'lodash/isEmpty'
import { computed, makeObservable } from 'mobx'
import type { $Keys } from 'utility-types'

import asyncAction from 'modules/core/lib/asyncAction'
import { Model } from 'modules/core/lib/mobx-rest'

const MEDIA_TYPES = {
  image: 'image',
  video: 'video',
}

const VIDEO_PROVIDERS = {
  youtube: 'youtube',
  vimeo: 'vimeo',
}

export type MediaType = $Keys<typeof MEDIA_TYPES>

export interface IOffice {
  id: number
  location_id: number
  name: string
  visible: boolean
  description: string | null
  media_type: string | null
  video_identifier: string | null
  video_provider: string | null
  location_image: string | null
}
class Office extends Model<IOffice> {
  static mediaTypes = MEDIA_TYPES
  static videoProviders = VIDEO_PROVIDERS

  constructor(attr: IOffice) {
    super(attr)
    makeObservable(this, {
      videoIdentifier: computed,
    })
  }

  static urlRoot() {
    return '/ats/locations'
  }

  get videoIdentifier(): string | null | undefined {
    const identifier = this.attributes.video_identifier

    if (isEmpty(identifier)) return identifier

    const provider = this.attributes.video_provider

    if (provider === VIDEO_PROVIDERS.youtube) {
      return `https://youtube.com/watch?v=${identifier}`
    }

    if (provider === VIDEO_PROVIDERS.vimeo) {
      return `https://vimeo.com/${identifier}`
    }

    return identifier
  }

  async addImage(image: File) {
    const result = await asyncAction(() =>
      this.rpc('add_image', {
        location_image: image,
      })
    )

    if (result.success) this.set(result.value)

    return Promise.resolve(result)
  }

  async removeImage() {
    const result = await asyncAction(() => this.rpc('remove_image', {}))

    if (result.success) this.set(result.value)

    return Promise.resolve(result)
  }
}

export default Office
